import {Directive, model} from '@angular/core';

/**
 * <b>usage:</b>
 * ```html
 * <div
 * 	[Lets]="{z: 1}" #lets="lets"
 * 	(mouseenter)="lets.patch({z: 2})"
 * 	(mouseleave)="lets.patch({z: 1})"
 * 	class="w-56 h-56 bg-red-500"
 * >
 * 	{{ lets.$().z }}
 * </div>
 * ```
 */
@Directive({
	selector: '[Lets]',
	exportAs: 'Lets',
	standalone: true,
})
export class LetsDirective<T = any> {
	$ = model.required<T>({
		alias: 'Lets',
	});

	constructor() {}

	patch(patch: Partial<T>) {
		const lets = this.$();
		this.$.set({...lets, ...patch});
	}
}
